import { getVivaConnectionsContext, isInVivaConnectionsApp } from 'vivaConnections';

type IsInvertedTheme = () => boolean;
export const isInvertedTheme: IsInvertedTheme = () => {
  if (!isInVivaConnectionsApp()) {
    //TODO: Read theme from Teams context and return whether theme is dark
    return false;
  }

  const { theme } = getVivaConnectionsContext();

  return theme === 'dark';
};
